import { gql } from "@apollo/client";
import { AccountFragment } from "fragments/account";

export const ViewFragment = gql`
  fragment ViewFragment on View {
    id
    viewId
    title
    description
    query
    tables
    params
    tags
    status

    createdAt
    updatedAt
  }
`;

export const get = gql`
  query ViewGet($viewId: String!) {
    viewer {
      id
      account {
        ...AccountFragment
        views {
          id
          get(viewId: $viewId) {
            ...ViewFragment
          }
        }
      }
    }
  }
  ${AccountFragment}
  ${ViewFragment}
`;

export const list = gql`
  query ViewList($input: ListInput) {
    viewer {
      id
      account {
        id
        views {
          id
          list(input: $input) {
            id
            last
            items {
              ...ViewFragment
            }
          }
        }
      }
    }
  }
  ${ViewFragment}
`;

export const create = gql`
  mutation ViewNew($input: ViewInputCreate!) {
    viewer {
      account {
        views {
          create(input: $input) {
            ...ViewFragment
          }
        }
      }
    }
  }
  ${ViewFragment}
`;

export const edit = gql`
  mutation ViewEdit($viewId: String!, $input: ViewInputUpdate!) {
    viewer {
      account {
        views {
          get(viewId: $viewId) {
            update(input: $input) {
              ...ViewFragment
            }
          }
        }
      }
    }
  }
  ${ViewFragment}
`;

export const remove = gql`
  mutation ViewRemove($viewId: String!) {
    viewer {
      account {
        views {
          get(viewId: $viewId) {
            remove
          }
        }
      }
    }
  }
`;

// One table's rows, for the engine to load.
//
// A query of its own rather than a field on the view, because the engine asks
// for tables ONE AT A TIME as it walks the AST — which is what makes a view that
// reads one of five tables download one of five row sets.
export const tableRows = gql`
  query ViewTableRows($tableId: String!) {
    viewer {
      id
      account {
        id
        tables {
          id
          get(tableId: $tableId) {
            id
            tableId
            rows {
              id
              etag
              count
              columns
              entries
            }
          }
        }
      }
    }
  }
`;

export const update = ({ viewId } = {}) => (cache) => {
  Object.keys(cache.data.data).forEach((key) => {
    if (key.includes(`views/queries`)) {
      cache.data.delete(key);
    }
  });
};
